import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageName } from 'src/app/core/enums/PageName';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { ChannelCustomerResponse } from './../../core/models/ChannelCustomerResponse';

@Injectable({ providedIn: 'root' })
export class RoutingService {

  private homePath = 'home';
  private fromPath = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService
  ) { }

  setFromPath(pathName: string) {
    this.fromPath = pathName;
  }

  getFromPath(): string {
    return this.fromPath;
  }

  navigate(pageName: PageName, data?: any) {
    switch (pageName) {
      case PageName.LandingPage: {
        this.navigationService.navigate([""], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.LoginPage: {
        this.navigationService.navigate(["login"], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.ForgotPasswordPage: {
        this.navigationService.navigate(["forgot-password"], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.ResetPasswordPage: {
        this.navigationService.navigate(["account", "profile", "reset-password"], { state: data });
        break;
      }
      case PageName.ForgotSuccessPage: {
        this.navigationService.navigate(["reset-success"], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.ForgotFailedPage: {
        this.navigationService.navigate(["reset-failed"], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.SignupPage: {
        this.navigationService.navigate(["register"], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.LoadingPage: {
        this.navigationService.navigate(["loading"], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.ProfilePage: {
        this.navigationService.navigate(["account", "profile"], { state: data });
        break;
      }
      case PageName.ResetMobilePage: {
        this.navigationService.navigate(["account", "profile", "reset-phone"], { state: data });
        break;
      }
      case PageName.OTPPage: {
        if (data && data?.pageName === PageName.ResetMobilePage) {
          this.navigationService.navigate(["account", "profile", "reset-phone-no"], { skipLocationChange: true, state: data });
        } else {
          this.navigationService.navigate(["otp"], { relativeTo: this.activatedRoute, state: data });
        }
        break;
      }
      case PageName.HomePage: {
        this.navigationService.navigate([this.homePath], { relativeTo: this.activatedRoute, state: data });
        break;
      }
      case PageName.CartPage: {
        this.navigationService.navigate(['cart'], { relativeTo: this.activatedRoute, state: data })
        break;
      }
      case PageName.CompleteOtpProfile: {
        this.navigationService.navigate(["complete-profile"]);
        break;
      }
      default: {
        break;
      }
    }
  }

  navigateHomeCheck(channelResponse : ChannelCustomerResponse){
      if(channelResponse.homeChannelTag != channelResponse.channelTag){
        this.navigateHomeUrl(channelResponse.homeChannelTag);
      }
      else{
        this.navigationService.navigate(["home"], {  relativeTo: this.activatedRoute });
      }
    }

    navigateHomeUrl(specificChannel?: string) {
    // this.navigationService.navigate([""]);
    this.navigationService.navigate(["home"], {  relativeTo: this.activatedRoute });
  }

}
